import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { Button, Toast } from 'react-bootstrap';
import useToast from '../../../hooks/useToast';
import FileIcon from '../icons/FileIcon';
import './FileInput.less';
import TableDocuments from '../../strategyProject/tabs/TabResults/TableDocuments';
import fetchConfig from '../../../fetchConfig';
import style from '../../strategyProject/tabs/TabResults/TabResults.module.less';
import { Tooltip } from '@material-ui/core';

const DEFAULT_SIZE_LIMIT_MB = 20;

export default function FileInput(props) {
  const sizeLimitMB = props.sizeLimitMB || DEFAULT_SIZE_LIMIT_MB;

  const addToast = useToast();
  const wrapperRef = useRef(null);

  const [fileList, setFileList] = props?.customState ? [props?.fileList ?? [], props?.onFileChange] : useState(props?.fileList || []);
  const onDragEnter = () => wrapperRef.current.classList.add('dragover');
  const onDragLeave = () => wrapperRef.current.classList.remove('dragover');
  const onDrop = () => wrapperRef.current.classList.remove('dragover');
  const checkValidSize = (sizeBytes) => sizeBytes <= (sizeLimitMB * 1024 * 1024);
  const checkValidExtension = f => {
    const fileSplitted = f.name.toString().split('.');
    const fileExtension = fileSplitted[fileSplitted.length - 1];
    return props.validExtensions
      ? props.validExtensions && Array.isArray(props.validExtensions) && props.validExtensions.includes(fileExtension)
      : true;
};

  const onFileDrop = (e) => {
    const newFiles = [...e.target.files].filter((f) => {
      const isValidSize = checkValidSize(f.size);
      if (!isValidSize) addToast.error(`Файл "${f.name}" превышает максимально допустимый размер`);
      const isValidExt = checkValidExtension(f)
      if (!isValidExt) addToast.error(`Файл "${f.name}" не является доупстимым по формату.`);
      return isValidSize && isValidExt;
    });
    if (newFiles) {
      const updatedList = props?.isSingle ? [...newFiles] : [...fileList, ...newFiles];
      !props?.customState && setFileList(updatedList);
      props.onFileChange(updatedList);
    }
  };

  const fileRemove = (file) => {
    file.id && props?.onDeleteFile(file.id);
    const updatedList = [...fileList];
    updatedList.splice(fileList.indexOf(file), 1);
    !props?.customState && setFileList(updatedList);
    props.onFileChange(updatedList);
  };
  const fileListContainer = useMemo(() => (fileList?.length > 0 ? (
    <div className="file-preview">
      {(props?.customState ? props?.fileList : fileList).map((item, index) => <FileView index={index} item={item} isMinioFiles={props.isMinio && item?.id} isDownloadable={!!props.downloadble && !!item?.id} disabled={props.disabled} fileRemove={fileRemove} />)}
    </div>
  ) : null), [fileList]);

  return (
    <>
      <div style={props.style}
        ref={wrapperRef}
        className={`file-input ${props.className}`}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div className="file-input__placeholder">
          <p className="file-input__placeholder-title">
            Нажмите или перетащите сюда, чтобы загрузить {props.isSingle ? ' файл' : 'файлы'}
          </p>
          <p className="file-input__placeholder-subtitle">
            Максимальный размер
            {' '}
            {props.isSingle ? '' : 'одного'}
            {' '}
            файла не более
            {' '}
            {sizeLimitMB}
            {' '}
            Мб
          </p>
          {props.format && <p className="file-input__placeholder-subtitle">
            Файл должен быть формата .{props.format}
          </p>}
          {props.message && <p className="file-input__placeholder-subtitle">
            {props.message}
          </p>}
        </div>
        <input required={props.required} disabled={props.disabled} type="file" multiple={!props?.isSingle} value="" onChange={onFileDrop} />
      </div>
      {fileListContainer}
    </>
  );
}

export function FileView({
  index, item, disabled, fileRemove, isDownloadable = false, isMinioFiles=false
}) {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');

  const token = sessionStorage.getItem('kctoken');

  const download = async () => {
    setLoading(true);
    const resp = isMinioFiles
    ? await fetch(`${fetchConfig.baseUrl}/minioFiles/download/${item.id}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }})
    : await fetch(`${fetchConfig.baseUrl}/files/download/${item.id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (resp.ok) {
      if (resp.headers.get('Content-Type') === 'application/octet-stream') {
        const blob = await resp.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = resp.headers.get('fileName')
          ? decodeURIComponent(resp.headers.get('fileName'))
          : item?.name;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(link);
        }, 200);
      } else {
        setError('Получен неверный тип данных');
        setShow(true);
      }
    } else {
      const error = resp.headers.get('Content-Type').indexOf('application/json') >= 0 ? (await resp.json()) : {};
      console.log(error);
      setError('Не удалось загрузить файл');
      setShow(true);
    }
    setLoading(false);
  };

  return (
    <>
      <div key={index} className={`file-preview__item ${!!isDownloadable && style.fileItem}`}>
        <div className="file-preview__item__info" onClick={!!isDownloadable && !loading ? download : null}>
          <FileIcon
            mimetype={item?.type ?? item?.contentType}
          />
          <p className="file-preview__item__name">{item?.name}</p>
        </div>
        {/* <p>{item.size}B</p> */}
        { !disabled && <Button disabled={disabled} onClick={() => fileRemove(item)} variant="light" className="btn-close" size="sm" />}

      </div>
      {!!isDownloadable && (
      <Toast
        style={{
          position: 'fixed', top: 0, right: 0, color: 'white',
        }}
        className="d-inline-block m-1"
        bg="danger"
        onClose={() => setShow(false)}
        show={show}
        delay={5000}
        autohide
      >
        <Toast.Body>
          {error}
        </Toast.Body>
      </Toast>
      )}
    </>
  );
}
